import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { secondary, darkGray, success } from 'styles/colorProvider';

export const UploadButton = styled(Button)`
  && {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: ${(props) =>
      props.outlined ? 'transparent' : props?.backgroundColor ? props?.backgroundColor : secondary};
    border: ${(props) => 'none'};
    outline: none;
    cursor: pointer;
    margin: 10px;
    transition: ${(props) => (props.showRequiredError ? 'none' : `all ease-in-out 0.3s`)};
    font-size: ${(props) => props.fontSize || '12px'};
    font-weight: normal;
    border-radius: 20px;
    height: ${(props) => props.height || '30px'};
    width: ${(props) => props.width || '230px'};
    color: ${(props) => (success && !props.outlined ? success : darkGray)};

    &&:hover {
      opacity: 0.7;
      color: ${(props) => (success && !props.outlined ? success : darkGray)};
      background-color: ${secondary};
    }

    &&:disabled {
      opacity: 0.7;
      cursor: default;
      color: ${(props) => (success && !props.outlined ? success : darkGray)};
    }

    @media (max-width: 1000px) {
      width: ${(props) => props.mobileWidth || '100%'};
    }
  }
`;
